import BaseComponent from '../BaseComponent';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Pagination from '../Pagination';

const NAME = 'GameMatchTable';

class GameMatchTable extends BaseComponent {
	constructor(element, viewUrl) {
		super(element);
		this._changeCallbacks = [];
		this.viewUrl = viewUrl;
		this.init();
	}

	onChange(callback) {
		this._changeCallbacks.push(callback);
	}

	static get NAME() {
		return NAME;
	}

	set tableData(data = []) {
		this._data = data.matchResults;
		this.pagination.data = {
			totalPages: Number.parseInt(+data.searchResultsCount / 10, 10) + 1,
			currentPage: +data.pageIndex,
		};
		this.render();
	}

	get tableData() {
		return this._data || [];
	}

	init() {
		this.table = SelectorEngine.findOne('.lta-match-table table', this._element);
		this.paginationElement = SelectorEngine.findOne('.lta-pagination', this._element);
		this.pagination = new Pagination(this.paginationElement);
		this.pagination.onChange((page) => {
			this.changeHandler(page);
		});
		this.render();
	}

	render() {
		this.renderTableData();
	}

	renderTableData() {
		this.tableBody = SelectorEngine.findOne('tbody');
		const tableBodyElement = this.tableData.map((rowData, index) => this.rowRenderer(rowData, index)).join('');
		this.tableBody.innerHTML = tableBodyElement;
	}

	rowRenderer(rowData) {
		const classes = `${rowData.Status === 'Pending' ? 'u-text-grey-ui-mid' : '' } u-body2 match-pending`;
		return `
			<tr class="${classes}">
				<td>${this.renderDateColumn(rowData)}</td>
				<td>${this.renderOpponent(rowData)}</td>
				<td>${this.renderWtn(rowData)}</td>
				<td>${this.renderScore(rowData)}</td>
				<td>${this.renderResult(rowData)}</td>
				<td>${this.renderMatchType(rowData)}</td>
				<td>${this.renderStatus(rowData)}</td>
				<td>${this.renderLink(rowData)}</td>
			</tr>
		`;
	}

	changeHandler(page) {
		for (const callback of this._changeCallbacks) {
			callback(page);
		}
	}

	renderDateColumn({ date }) {
		return date;
	}

	renderOpponent({ opponent1, opponent2 }) {
		return `<span> ${opponent1 + (opponent2 ? ', ' : '')}</span>${opponent2 ? '<br />' + opponent2 : '' }`;
	}

	renderWtn(rowData) {
		return `<span class="">${(rowData.opponent2 ? rowData.opponent1DoublesWtn +  '<br />' + rowData.opponent2DoublesWtn : rowData.opponent1SinglesWtn)}</span>`;
	}

	renderScore({ score, colorForScoreAndResult }) {
		if(!score) {
			return '';
		}
		const formattedScore = score.split(' ').map((item) => {
			const tieScore = item.match(/\(([^)]+)\)/);
			const actualScore = item.split('(')[0];
			if(!!tieScore && !!tieScore[1]) {
				return `${actualScore}<sup>${tieScore[1]}</sup>`;
			}
			return actualScore;
		}).join(', ');
		const classes = colorForScoreAndResult === 'red' ? 'u-text-status-red' :'u-text-status-green';
		return `<span class="${classes}">${formattedScore}</span>`;
	}

	renderResult({ Result, colorForScoreAndResult }) {
		const classes = colorForScoreAndResult === 'red' ? 'u-text-status-red' :'u-text-status-green';
		return `<span class="${classes}"> ${Result}</span>`;
	}

	renderMatchType({ matchType }) {
		return matchType;
	}

	renderStatus({ Status, matchSource, isNewRequest }) {
		//if(matchSource !== "Competition") { Removing this as per #19100
		if (isNewRequest) {
			return `<span class="lta-tag lta-tag--warning">• NEW REQUEST</span>`;
		}
		return Status;
		//}
		//return ``;
	}

	renderLink(params) {
		const url = this.viewUrl;
		//if(params?.matchSource !== "Competition") { Removing this as per #19100
		return `<a href="${url + `?matchId=${params.Id}`}" rel="" class="u-link3 u-text-lta-dark-blue">View
				<svg class="lta-icon js-lta-text-input--btn-icon" width="1em" height="1em" fill="currentColor" alt="caret-right-fill" aria-hidden="true">
					<use xlink:href="/static/images/icons/lta-icons.svg#caret-right-fill"></use>
				</svg>
			</a>`;
		//}
		//return ``;
	}
}

export default GameMatchTable;
